export const updateWalletTransactions = (state, action) => {
    state.walletTransactions = action.payload;
};

export const updateRazorpayRefresh = (state, action) => {
    state.razorpayRefresh = action.payload;
};
// razorpayRefresh;
